export default __webpack_public_path__ + "static/media/info-icon.389b9f0e.svg";